import React, { useEffect, useState } from "react";
import "./ItemModal.scss"
import { Popup } from "witmeg-ui-system";
import { Select } from "antd";
import config from "react-global-configuration";
import { setOrderData } from "../../../../../../../../redux/resturantWidgetSlice";
import { useDispatch, useSelector } from "react-redux";
import { getLocalStorageData, LOCAL_STORAGE_ITEMS_NAMES, setLocalStorageData } from "../../../../../../utilities/helper";
import close from "../../../assets/close.svg"

const TableModal = ({ visibility, floors, tables, setTables, selectedTable, selectedFloor, setSelectedTable, setSelectedFloor, onClose }) => {
    const { Option } = Select;
    const [table, setTable] = useState(selectedTable)
    const [floor, setFloor] = useState(selectedFloor)
    const [shoowDropdown, setShowDropDown] = useState(false)
    const [floorChange, setFloorChange] = useState(null)
    const restaurantDataState = useSelector((state) => state.resturantData);
    const dispatch = useDispatch()
    const isCartDataAvailable = restaurantDataState.orderCartData && restaurantDataState.orderCartData.Items.length ? true : false;

    useEffect(() => {
        setTable(selectedTable)
        setFloor(selectedFloor)
    }, [selectedTable, selectedFloor])
    useEffect(() => {
        if (visibility) {
            console.log("tetst")
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }

        return () => {
            document.body.style.overflow = "auto";
        };
    }, [visibility]);

    useEffect(() => {
        if (shoowDropdown) {
            setTable(null)
            setTables([])
            setTimeout(() => {
                if (floors) {
                    let Tables = floors?.find((floorItem) => floorItem.ID === floor.Id)?.Tables
                    if (Tables !== undefined) {
                        let selected = Tables[0]
                        let tableValue = {
                            TableID: selected.ID,
                            TableName: selected.TableName,
                            LocalReference: { Id: selected.LocalID },
                            Floor: floor
                        }
                        setTable(tableValue)
                        setTables(Tables)
                    }
                }
            }, 0);
        }
    }, [floorChange])
    return (
        <Popup
            className='TableModal'
            modalVisible={true}
            modalTitle=""
            mask={true}
            centered
            onCancel={() => {
            }}
            closable={false}>
            <div className="TableModal-modal-inner">
                <div className="TableModal-modal-inner-close-icon"
                    onClick={() => {
                        onClose()
                    }}><img alt="" src={close} /></div>
                <div
                    className="TableModal-modal-inner-hdr-logo"
                >
                    <img
                        src={config.get("companyLogo")}
                        draggable="false"
                        className="TableModal-modal-inner-hdr-logo"
                    />
                </div>

                {shoowDropdown ?
                    <div className="floor-dropdown">
                        <div className="floor-drop-container">
                            <div className="label">Area</div>
                            <Select className="select-floor"
                                onChange={(id) => {
                                    let selected = floors.find((floor) => floor.ID === id)
                                    let floorValue = {
                                        Id: selected.ID,
                                        Name: selected.ItemName.Translations.en,
                                        LocalReference: { Id: selected.LocalID }
                                    }
                                    setFloorChange(floorValue)
                                    setFloor(floorValue)

                                }}
                                value={floor ? floor.Name : ""}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                dropdownStyle={{ zIndex: 9999 }}
                            >
                                {floors && floors?.map((itemFloor, key) => {
                                    return (
                                        <Option value={itemFloor.ID} key={key}>
                                            {itemFloor.ItemName.Translations.en}
                                        </Option>
                                    )
                                }
                                )}
                            </Select>
                        </div>
                        <div className="floor-drop-container">
                            <div className="label">Table</div>
                            {tables && <Select className="select-floor"
                                onChange={(id) => {
                                    let selected = tables.find((table) => table.ID === id)
                                    let tableValue = {
                                        TableID: selected.ID,
                                        TableName: selected.TableName,
                                        LocalReference: { Id: selected.LocalID },
                                        Floor: floor,
                                        Covers: selected.Covers
                                    }
                                    setTable(tableValue)

                                }}
                                value={table ? table.TableName : ""}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                dropdownStyle={{ zIndex: 9999 }}
                            >
                                <Option value=''>
                                </Option>
                                {tables && tables?.map((tableValue, key) => {
                                    return (
                                        <Option value={tableValue.ID} key={key}>
                                            {tableValue.TableName}
                                        </Option>
                                    )
                                }
                                )}
                            </Select>}

                        </div>
                    </div> :
                    <div className="TableModal-modal-inner-container">
                        <div className="TableModal-modal-inner-container-inner">
                            <div className="TableModal-modal-inner-container-inner-left">Area</div>
                            <div className="TableModal-modal-inner-container-inner-right">{floor?.Name}</div>
                        </div>
                        <div className="TableModal-modal-inner-container-inner">
                            <div className="TableModal-modal-inner-container-inner-left">Table</div>
                            <div className="TableModal-modal-inner-container-inner-right">{table?.TableName}</div>
                        </div>
                        <div className="TableModal-modal-inner-container-link">Not your table? <span
                            onClick={() => { setShowDropDown(true) }}>Click here</span></div>
                    </div>}
                {shoowDropdown ? <div
                    className="TableModal-modal-inner-btn"
                    onClick={() => { setShowDropDown(false) }}>Update</div> :
                    <div
                        className="TableModal-modal-inner-btn"
                        onClick={async () => {
                            localStorage.setItem("selected_table", JSON.stringify(table))
                            setSelectedTable(table)
                            setSelectedFloor(floor)
                            let menuDataValue = await getLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA);
                            let storageData = {
                                ...menuDataValue,
                                tableLocalId: table?.LocalReference?.Id

                            }
                            await setLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA, storageData);
                            if (isCartDataAvailable) {
                                let updatedData = { ...restaurantDataState.orderDetails, FulfillmentType: restaurantDataState.orderDetails.FulfillmentType, DineIn: table }
                                dispatch(setOrderData(updatedData))
                            }
                            onClose()
                        }}>
                        Start Order
                    </div>}
            </div>
        </Popup>
    )
}
export default TableModal